module.exports = __webpack_public_path__ + "static/media/users.7feef7a1.png";